import React from 'react';
var Spinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '2rem' : _b;
    var style = {
        width: size,
        height: size,
    };
    return (React.createElement("div", { style: style },
        React.createElement("div", { className: 'spinner dark:border-[rgba(255,255,255,0.25)] dark:border-t-white' })));
};
export default Spinner;
